
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

 // Vendor
require('../vendor/bootstrap');
require('devextreme/integration/jquery');
//var signaturePad = require('signature_pad/dist/signature_pad');

// Components
require('./components/generic');
require('./components/alerts');
require('./components/workorders');
require('./components/tooltips');
require('./components/forms');
require('./components/planner');
require('./components/dates');
require('./components/datefields');
require('./components/datagrid');
//require('./components/colorpicker');
require('./components/bulkactions');
require('./components/modals');
require('./components/dev');
require('./components/overlays');
require('./components/filterlist');
require('./components/employee');
require('./components/ajaxPosts');
require('./components/sidebarSticky');
require('./components/project');
require('./components/projects');
require('./components/workordersMobile');
window.addEventListener('mousewheel', (event) => {
    event.preventDefault()

  }, { passive: false })



// WEBPACK FOOTER //
// ./resources/js/app.js